const en = {
  backToEquipment: '← Back to Equipment',
  title: 'Equipment Report',
  reportTitle: 'Equipment Production Report',
  week: 'Week',
  month: 'Month',
  year: 'Year',
  allYears: 'All Years',
  allMonths: 'All Months',
  allBrands: 'All Brands',
  allCategories: 'All Categories',
  clear: 'Clear',
  print: '🖨️ Print',
  generated: 'Generated: {{date}}',
  groupedBy: 'Grouped by: {{groupBy}}',
  totalEquipment: 'Total Equipment',
  totalPartsUsed: 'Total Parts Used',
  groups: 'Groups',
  uniqueModels: 'Unique Models',
  noEquipmentFound: 'No equipment found for the selected filters',
  units: '{{count}} units',
  parts: '{{count}} parts',
  colModel: 'Model',
  colBrand: 'Brand',
  colCategory: 'Category',
  colQty: 'Qty',
  colSerialNumbers: 'Serial Numbers',
  subtotal: 'Subtotal:',
  footerSystem: 'Dynavox Equipment Management System',
  footerPage: 'Page 1 of 1',
  weekLabel: 'Week {{weekNum}}, {{year}} ({{range}})',
  months: {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
  },
};

const de = {
  backToEquipment: '← Zurück zur Ausrüstung',
  title: 'Ausrüstungsbericht',
  reportTitle: 'Ausrüstungs-Produktionsbericht',
  week: 'Woche',
  month: 'Monat',
  year: 'Jahr',
  allYears: 'Alle Jahre',
  allMonths: 'Alle Monate',
  allBrands: 'Alle Marken',
  allCategories: 'Alle Kategorien',
  clear: 'Zurücksetzen',
  print: '🖨️ Drucken',
  generated: 'Erstellt: {{date}}',
  groupedBy: 'Gruppiert nach: {{groupBy}}',
  totalEquipment: 'Ausrüstung gesamt',
  totalPartsUsed: 'Verwendete Teile gesamt',
  groups: 'Gruppen',
  uniqueModels: 'Eindeutige Modelle',
  noEquipmentFound: 'Keine Ausrüstung für die gewählten Filter gefunden',
  units: '{{count}} Einheiten',
  parts: '{{count}} Teile',
  colModel: 'Modell',
  colBrand: 'Marke',
  colCategory: 'Kategorie',
  colQty: 'Menge',
  colSerialNumbers: 'Seriennummern',
  subtotal: 'Zwischensumme:',
  footerSystem: 'Dynavox Ausrüstungsverwaltungssystem',
  footerPage: 'Seite 1 von 1',
  weekLabel: 'Woche {{weekNum}}, {{year}} ({{range}})',
  months: {
    1: 'Januar',
    2: 'Februar',
    3: 'März',
    4: 'April',
    5: 'Mai',
    6: 'Juni',
    7: 'Juli',
    8: 'August',
    9: 'September',
    10: 'Oktober',
    11: 'November',
    12: 'Dezember',
  },
};

const equipmentReport = { en, de };
export default equipmentReport;
